<div class="shadow-gray-500/20">
  <div class="flex justify-center text-center text-2xl">{{utility.traslatei18n(data.title)}}</div>
  <div class="flex justify-center text-center text-lg mt-4">{{utility.traslatei18n(data.question)}}</div>
  <div mat-dialog-actions class="flex justify-center text-center text-lg mt-4 space-x-8">
    <button mat-flat-button mat-dialog-close color="accent" (click)="logoutUser()">{{utility.traslatei18n(data.yes)}}</button>
    <button mat-flat-button mat-dialog-close cdkFocusInitial>{{utility.traslatei18n(data.no)}}</button>
  </div>
</div>